import { useNavigate } from "react-router-dom";
import api from "../services/Api";

export const useVerificaPermissao = () => {
  const navigate = useNavigate();

  const verificaPermissao = async (idPerfil, idAcao) => {
    try {
      const response = await api.get(`/permissao/${idPerfil}/${idAcao}`);

      if (response.data.permissao === 0) {
        navigate("/usina/unauthorized");
      }
    } catch (error) {
      console.error("Erro ao verificar permissão:", error);
    }
  };

  return verificaPermissao;
};
